import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { render } from "react-dom";
import { AgGridReact } from "ag-grid-react";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../util/constants";
import Encrypt from "./../util/encrypt";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import OffSiteLocationModalComp from "./OffSiteLocationModalComp";

const OffSiteLocaComp = () => {
  const gridRef = useRef();
  const dispatch = useDispatch();

  const [modalShow, isModalShow] = useState(false);
  const [typeOfModel, setTypeOfModel] = useState("Edit");
  const [cellData, setCellClickData] = useState(null);
  let rowData = useSelector((state) => state.location.getLocationData);
  rowData = rowData?.filter((data,i)=>{
    return data?.is_active === true;
  })
  const [loginResponse, setLoginResponse] = useState(null);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }
    dispatch({
      type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATION_API_CALL,
    });
  }, []);

  const cellImageRender = (params) => {
    return (
      <div className="" style={{ display: "flex", flexDirection: "row" }}>
        <div
          onClick={() => {
            setCellClickData(params.data);
            showModal(true);
            setTypeOfModel("edit");
          }}
        >
          <img
            style={{ marginLeft: 20 }}
            alt="actions"
            src={require("./../assets/Dashboard/actions.png")}
          />
        </div>
        <div
          onClick={() => {
            setCellClickData(params.data);
            showModal(true);
            setTypeOfModel("delete");
          }}
        >
          <img
            style={{ marginLeft: 20 }}
            alt="cancel"
            src={require("./../assets/Dashboard/cancel.png")}
          />
        </div>
      </div>
    );
  };
  const cellDivisionRender = (params) => {
    const division_names = (params?.data?.divisions || []).map(entry => entry.divisionName).join(', ');


    return (
      <div className="" style={{ display: "flex", flexDirection: "row" }}>
        {division_names}
      </div>
    );
  };

  const [columnDefs] = useState([
    { field: "name", filter: true, resizable: true, flex: 1 },
    { field: "streetAddress", filter: true, resizable: true, flex: 1 },
    { field: "city", filter: true, resizable: true, flex: 1 },
    { field: "state", filter: true, resizable: true, flex: 1 },
    { field: "zip", filter: true, resizable: true, flex: 1 },
    { field: "phone", filter: true, resizable: true, flex: 1 },
    { field: "contactFirstName", filter: true, resizable: true, flex: 1 },
    { field: "TrailerCount", filter: true, resizable: true, flex: 1 },
    { field: "Division", filter: true, resizable: true, flex: 1,cellRenderer:cellDivisionRender  },
    {
      field:
        loginResponse &&
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
          loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN ||
          loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN)
          ? ""
          : "Actions",
      filter: true,
      resizable: false,
      flex: 1,
      cellRenderer: cellImageRender,
    },
  ]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true,
  }));

  const buttonListener = useCallback((e) => {
    gridRef.current.api.deselectAll();
  }, []);

  const cellClickedListener = useCallback((event) => {}, []);

  const showModal = (isShow) => {
    isModalShow(isShow);
  };

  return (
    <div className="row">
      {modalShow ? (
        <OffSiteLocationModalComp
          title={
            typeOfModel === "delete"
              ? "Delete Off-Site Location"
              : cellData != null
              ? "Edit Off-Site Location"
              : "Add Off-Site Location"
          }
          typeOfModel={typeOfModel}
          show={showModal}
          handleClose={showModal}
          OffSiteLocation={true}
          isShow={showModal}
          rowDataUser={cellData}
          setValue={(value) => {
            isModalShow(false);
            setTypeOfModel('');
            if (cellData != null) {
                console.log("edit api",value);

              setCellClickData(null);
              dispatch({
                type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
                  .EDIT_LOCATION_API_CALL,
                payload: { value: value },
              });
            } else {
                console.log("add  api",value);

              dispatch({
                type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
                  .ADD_LOCATION_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}

      <div className="col-md-12 col-sm-12 col-12">
        {loginResponse &&
        (loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
          loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN) ? (
          <div
            onClick={() => {
              setCellClickData(null);
              isModalShow(true);
            }}
            className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              margin: "2px 0 2px 0px",
            }}
          >
            <img
              src={require("./../assets/Dashboard/plus.png")}
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            ></img>
          </div>
        ) : null}

        <div
          className="col-md-12 col-sm-12 row-10 ag-theme-alpine"
          style={{
            height: "80vh",
            width: "80vw",
            margin: "auto",
          }}
        >
          <AgGridReact
            ref={gridRef}
            suppressColumnVirtualisation={true}
            defaultColDef={defaultColDef}
            animateRows={true}
            rowSelection="multiple"
            onCellClicked={cellClickedListener}
            rowData={rowData}
            columnDefs={columnDefs}
          ></AgGridReact>
        </div>
      </div>
    </div>
  );
};
export default OffSiteLocaComp;
